<template>
  <a-popconfirm title="此操作将强制刷新页面，并清理缓存，您确定执行吗?" ok-text="确定" cancel-text="取消" @confirm="confirm" @cancel="cancel">
    <a-badge>
      <a-icon v-if='this.renewal' slot="count" type="clock-circle" style="color: #f5222d" />
      <div class="cache-box" v-if="false">
        <span class="cache-box-icon">
          <a-icon type="cloud-sync" />
        </span>
        <div>清缓存</div>
      </div>
    </a-badge>
  </a-popconfirm>
</template>

<script>
import { toClearCache } from '@/utils/utils';
import MqttClient from '@/utils/MqttClient';

export default {
  data() {
    return {
      mq: null,
      assemble: [
        {
          name: '192',
          keys: [
            'bu_pc_trade',
            'bu_pc_merchant',
            'bu_pc_dispatch',
            'bu_pc_settlement',
            'bu_pc_crm',
            'bu_pc_diting',
            'infra-web-workflow',
            'infra-web-cli',
            'infra-web-authority',
            'deviceCenter',
            'infra-web-financial',
            'bu_pc_call',
            'bu_pc_telemarketing',
            'bu_pc_scfinance',
            'bu_pc_csd',
            'bu_pc_productInfohub',
            'bu_pc_delivery',
            'infra-web-base',
          ],
          appId: '10004',
        },
        {
          name: 'boss',
          keys: [
            'bu_pc_trade',
            'bu_pc_merchant',
            'bu_pc_dispatch',
            'bu_pc_settlement',
            'bu_pc_crm',
            'bu_pc_diting',
            'infra-web-workflow',
            'infra-web-cli',
            'infra-web-authority',
            'deviceCenter',
            'infra-web-financial',
            'bu_pc_call',
            'bu_pc_telemarketing',
            'bu_pc_scfinance',
            'bu_pc_csd',
            'bu_pc_productInfohub',
            'bu_pc_delivery',
            'infra-web-base',
          ],
          appId: '10004',
        },
        {
          name: 'tboss',
          keys: [
            'infra-web-workflow',
            'infra-web-cli',
            'infra-web-authority',
            'scm_pc_service',
            'scm_pc_logistics',
            'scm_pc_trade',
            'scm_pc_capital',
            'scm_pc_deliver',
            'infra-web-message',
            'scm_pc_main_logistics',
            'infra-web-base',
          ],
          appId: '20001',
        },
        {
          name: 'diting',
          keys: [
            'bu_pc_trade',
            'bu_pc_diting',
            'infra-web-authority',
            'bu_pc_merchant',
            'bu_pc_dispatch',
            'bu_pc_settlement',
            'infra-web-workflow',
            'infra-web-cli',
            'infra-web-message',
            'infra-web-base',
          ],
          appId: '10013',
        },
        {
          name: 'paladin',
          keys: [
            'bu_pc_trade',
            'bu_pc_diting',
            'infra-web-authority',
            'bu_pc_merchant',
            'bu_pc_dispatch',
            'bu_pc_settlement',
            'infra-web-workflow',
            'infra-web-cli',
            'infra-web-message',
            'infra-web-base',
          ],
          appId: '10013',
        },
        {
          name: 'crm',
          keys: [
            'bu_pc_merchant',
            'bu_pc_crm',
            'infra-web-authority',
            'infra-web-workflow',
            'merchant_crm_pc',
            'infra-web-workflow',
            'infra-web-message',
            'infra-web-base',
          ],
          appId: '10007',
        },
        {
          name: 'sh',
          keys: [
            'deviceCenter',
            'infra-web-authority',
            'infra-web-workflow',
            'infra-web-message',
            'infra-web-base',
          ],
          appId: '10009',
        },
        {
          name: 'farm',
          keys: [
            'infra-web-authority',
            'infra-web-workflow',
            'infra-web-cli',
            'infra-web-message',
            'infra-web-admin',
            'infra-web-base',
          ],
          appId: '90001',
        },
        {
          name: 'xirang',
          keys: [
            'infra-web-authority',
            'infra-web-workflow',
            'infra-web-cli',
            'infra-web-message',
            'infra-web-admin',
            'infra-web-base',
          ],
          appId: '90001',
        },
        {
          name: 'ccs',
          keys: [
            'infra-web-authority',
            'infra-web-cli',
            'infra-web-message',
            'bu_pc_trade',
            'bu_pc_merchant',
            'bu_pc_dispatch',
            'bu_pc_settlement',
            'bu_pc_clue',
            'infra-web-base',
          ],
          appId: '10015',
        },
        {
          name: 'skydome',
          keys: [
            'infra-web-authority',
            'infra-web-cli',
            'infra-web-message',
            'customer_saas_pc',
            'infra-web-base',
          ],
          appId: '10016',
        },
        {
          name: 'finance',
          keys: [
            'infra-web-authority',
            'infra-web-cli',
            'infra-web-message',
            'infra-web-workflow',
            'bu_pc_settlement',
            'merchant_crm_pc',
            'bu_pc_scfinance',
            'infra-web-base',
          ],
          appId: '10019',
        },
        {
          name: 'themis',
          keys: [
            'infra-web-authority',
            'infra-web-cli',
            'infra-web-message',
            'infra-web-workflow',
            'bu_pc_themis',
            'infra-web-base',
          ],
          appId: '10020',
        },
        {
          name: 'tms',
          keys: [
            'infra-web-authority',
            'infra-web-cli',
            'infra-web-message',
            'infra-web-workflow',
            'scm_pc_service',
            'scm_pc_logistics',
            'scm_pc_trade',
            'scm_pc_capital',
            'scm_pc_deliver',
            'scm_pc_main_logistics',
            'infra-web-base',
          ],
          appId: '20001',
        },
      ],
      renewal: !!localStorage.getItem('Renewal'),
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.mq = new MqttClient();
      this.mq.subscribeTopic('servicePushMqttTopic');
      this.mq.receiveMessageWithTopic((topic, msg) => {
        try {
          const msglist = JSON.parse(msg);
          if (msglist && msglist.tag) {
            const releases = localStorage.getItem('ZNMONITOR_RELEASE') ? JSON.parse(localStorage.getItem('ZNMONITOR_RELEASE')) : {};
            releases[msglist.key || msglist.serviceName || 'error'] = msglist.tag;
            localStorage.setItem('ZNMONITOR_RELEASE', JSON.stringify(releases));
          }
          // {
          //     "title": "发布通知",
          //     "key": "infra-web-cli",
          //     "commitId": "f4651c42",
          //     "tag": ""
          // }
          /**
           * 判断msglist.key在当前域名是否有 有就提示 没有就不提示
           */
          this.cacheIdentifier(msglist);
        } catch (error) {
        }
      });
    },
    cacheIdentifier(val) {
      if (!val.key) {
        return;
      }
      let keys = [];
      const urls = window.location.hostname.toString();
      this.assemble.forEach((em) => {
        if (urls.indexOf(em.name) !== -1 && em.appId === localStorage.getItem('appId')) {
          keys = em.keys;
        }
      });
      keys.forEach((im) => {
        // eslint-disable-next-line eqeqeq
        if (val.key == im) {
          localStorage.setItem('Renewal', '1');
          this.renewal = true;
        }
      });
    },
    confirm() {
      toClearCache();
    },
    cancel(e) {
      console.log(e);
    },
  },
};
</script>
<style lang="less" scoped>
.ant-badge {
  margin-right: 24px;
}

.cache-box {
  cursor: pointer;
  display: flex;
  font-size: 14px;
  width: 80px;

  &-icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    font-size: 24px;
    margin-right: 4px;
    position: relative;

    i {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
  }

  div {
    flex: 1;
    color: #333333;
    vertical-align: middle;
    text-align: center;
    line-height: 24px;
  }
}
</style>
<style>
.ant-btn-primary {
  background-color: #3673ff;
  border-color: #3673ff;
}
</style>
